import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ApBaseClass } from 'webcommon/shared';

import { FcFilterModalContext } from '../../../models/index';

@Component({
  selector: 'fc-general-filter-modal',
  templateUrl: './fc-general-filter-modal.component.html',
  styleUrls: ['./fc-general-filter-modal.component.less'],
})
export class FcGeneralFilterModalComponent extends ApBaseClass {
  @Input() disableClear = false;
  @Input() baseId = '';
  @Input() fcFilterModalContext: FcFilterModalContext;
  @Input() form: FormGroup;

  @Output() cancel = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();
  @Output() apply = new EventEmitter<FormGroup>();

  public isLoading = false;

  constructor() {
    super();
  }

  public onApply(): void {
    this.apply.emit();
  }

  public onCancel(): void {
    this.cancel.emit();
  }

  public onClear(): void {
    this.clear.emit();
  }
}
